/*
 * Created with vue 2
 * Author: Jay/jaytanweb@163.com
 * Date: 2018/4/12
 * Time: 10:05
 */
<template>
  <div id='index' class="index" title="신삼국지 모바일-코에이 테크모 인증">
    <div class="index-mask" :class="{ 'index-mask-visible': ifIndexMaskVisible }"><p>주군님께 보다 나은 정보전달을 위해 홈페이지를 세로로 보시길 바랍니다.</p></div>
    <div id="swiperContainer">
      <page1 class="swiper-base" @onVideoVisible="toggleVideoFrameVisibility"></page1>
      <page2 class="swiper-base" @visibilityChange="changeGalleryVisibility"></page2>
      <page3 class="swiper-base"></page3>
    </div>
    <navBar :make-it-light="makeItLight" class="navBar" @fullpageChange="onfullpageChange"></navBar>
    <!-- <page4></page4> -->
    <gallery :group-name="galleryGroupName" @visibilityChange="changeGalleryVisibility" :class="{ 'gallery-opacity': galleryVisibility }"></gallery>
    <!--<loading></loading>-->
    <videoFrame :visible="videoFrameVisibility" @onVideoVisible="toggleVideoFrameVisibility"></videoFrame>
    <alert/>
  </div>
</template>

<script>
import videoFrame from '@/index/video'
import alert from '@/event/alert'
import loading from '@/components/loading'
import navBar from '@/index/navBar'
import gallery from '@/index/gallery'
import page1 from '@/index/page1'
import page2 from '@/index/page2'
import page3 from '@/index/page3'
// import page4 from '@/index/page4'

import { mapMutations } from 'vuex'
export default {
  name: 'index',
  data () {
    return {
      waiting: false,
      min: 0,
      max: 0,
      galleryVisibility: false,
      galleryGroupName: '',
      videoFrameVisibility: false,
      whichPageIsOnView: 0,
      makeItLight: 0,
      ifIndexMaskVisible: false
    }
  },
  components: {
    videoFrame: videoFrame,
    loading: loading,
    navBar: navBar,
    gallery: gallery,
    page1: page1,
    page2: page2,
    page3: page3,
    alert: alert
    // page4: page4
  },
  methods: {
    ...mapMutations([
      'setStopBgChangeCountDown'
    ]),
    changeNav (val) {
      this.makeItLight = val
    },
    toggleIndexMaskVisible () {
      if (this.$lib.IsPC()) return false
      // const $ = document.querySelectorAll.bind(document)
      window.addEventListener('resize', (ev) => {
        if (window.orientation === 90 || window.orientation === -90) {
          this.ifIndexMaskVisible = true
        } else {
          this.ifIndexMaskVisible = false
        }
      })
    },
    toggleVideoFrameVisibility () {
      this.videoFrameVisibility = this.videoFrameVisibility === false
    },
    toggleControl () {
      let that = this
      let showingPage = 0
      this.$lib.wheelScrollCheck({
        id: 'index',
        RE: 30,
        prevent: true,
        cb: function (dir, delta) {
          console.log('wheel index：', dir)
          // if (that.waiting) console.log('________________wait________________')
          if (dir === 'up' && !that.waiting) {
            showingPage = (showingPage + 1) >= that.max ? that.max - 1 : showingPage + 1
            that.swipeIt({jumpTo: showingPage})
          } else if (dir === 'down' && !that.waiting) {
            showingPage = (showingPage - 1) < that.min ? that.min : showingPage - 1
            that.swipeIt({jumpTo: showingPage})
          }
        }
      })
      this.$lib.touchmoveCheck({
        id: 'index',
        RE: 30,
        prevent: true,
        cb: function (dir, delta) {
          console.log('touch index：', dir)
          // if (that.waiting) console.log('________________wait________________')
          if (dir === 'up' && !that.waiting) {
            showingPage = (showingPage + 1) >= that.max ? that.max - 1 : showingPage + 1
            that.swipeIt({jumpTo: showingPage})
          } else if (dir === 'down' && !that.waiting) {
            showingPage = (showingPage - 1) < that.min ? that.min : showingPage - 1
            that.swipeIt({jumpTo: showingPage})
          }
        }
      })
    },
    swipeIt ({init, jumpTo}) {
      const $ = document.querySelectorAll.bind(document)
      let that = this
      let nodes = $('#swiperContainer')[0].childNodes
      let child = []
      Array.from(nodes).forEach(arr => {
        if (arr.nodeType === 1) {
          child.push(arr)
        }
      })
      if (init) {
        // console.log('swiperInit,child.length:', child.length)
        this.max = child.length
        child.forEach((arr, index) => {
          arr.classList.add(`swiper-${index}`)
        })
      } else {
        console.log('jumpTo:', jumpTo, 'waiting:', this.waiting)
        this.waiting = true
        that.changeNav(jumpTo)
        child.forEach((arr, index) => {
          if (index < parseInt(jumpTo)) {
            arr.classList.remove('swiper-0')
            arr.classList.remove('swiper-1')
            arr.classList.add('swiper-2')
            setTimeout(function () {
              that.waiting = false
            }, 1000)
          } else if (index > parseInt(jumpTo)) {
            arr.classList.remove('swiper-0')
            arr.classList.remove('swiper-2')
            arr.classList.add('swiper-1')
            setTimeout(function () {
              that.waiting = false
            }, 1000)
          } else {
            arr.classList.remove('swiper-1')
            arr.classList.remove('swiper-2')
            arr.classList.add('swiper-0')
            setTimeout(function () {
              that.waiting = false
            }, 1000)
          }
        })
      }
    },
    changeGalleryVisibility (name = '') {
      console.log('show gallery ->', name)
      if (name) {
        this.galleryGroupName = name
        this.galleryVisibility = true
      } else {
        this.galleryVisibility = false
      }
    },
    onfullpageChange (id) {
      // console.warn('即将跳转：', id)
      this.swipeIt({ jumpTo: id - 1 })
    }
  },
  mounted: function () {
    // index mounted
    this.swipeIt({init: true})
    this.toggleIndexMaskVisible()
    // this.swipeIt({jumpTo: 2})
    this.toggleControl()
    // setTimeout(function () {
    //   // console.log('2-2')
    //   document.body.style.background = '#fff'
    // }, 6000)
    this.setStopBgChangeCountDown() // 停止错误提示背景切换倒计时
    console.log('do stop ___________', this.$store.state.stopBgChangeCountDown)
  }
}
</script>

<style type="text/scss" lang="scss" scoped>
.index {
  //begin you code
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #000;
  .gallery-opacity {
    display: block;
    opacity: 1;
    .gallery-container {
      display: block;
      opacity: 1;
    }
  }
  .index-mask {
    display: none;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.9);
    z-index: 999;
    p {
      position: relative;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      line-height: .50rem;
      font-size: .30rem;
      color: #fff;
      text-align: center;
      padding: 0 .95rem;
    }
  }
  .index-mask-visible {
    display: block;
    opacity: 1;
  }
  #swiperContainer {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .swiper-base {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    background-size: cover;
    overflow: hidden;
    transition: all .7s;
  }
  .swiper-0 {
    z-index: 2;
    opacity: 1;
    transform: scale(1, 1);
  }
  .swiper-1 {
    z-index: 0;
    opacity: 0;
    transform: scale(2, 2);
  }
  .swiper-2 {
    z-index: 0;
    opacity: 0;
    transform: scale(.3, .3);
  }
}
</style>



// WEBPACK FOOTER //
// src/page/index.vue